import PropTypes from 'prop-types';

import BasicBreadcrumbs from '@zenbusiness/zui/BasicBreadcrumbs';

import { useProductsBreadcrumbs } from './hooks/useProductsBreadcrumbs';

function ProductsBreadcrumbs({ productId }) {
  const breadcrumbItems = useProductsBreadcrumbs(productId);

  return (
    <BasicBreadcrumbs items={breadcrumbItems} />
  );
}

export default ProductsBreadcrumbs;

ProductsBreadcrumbs.propTypes = {
  productId: PropTypes.string
};
